import {
  ApplicationConfig,
  ApplicationConfigWithPages,
  AppCategory,
  AppMappings,
  WebAppCategory,
  WebAppMapping,
} from './appConfig.models';
import { Action } from '@ngrx/store';
import { ROOT_EFFECTS_INIT } from '@ngrx/effects';
import { AppMode } from './appConfig.reducer';
import { Shifts } from '../../../../modules/battery-pool/models/models';
import { RatedCapacity } from '../../../../core/services';
export enum AppConfigActionTypes {
  ADD_APP_CONFIG = '[AppConfig] ADD',
  ADD_APP_CONFIG_SUCCESS = '[AppConfig] ADD SUCCESS',
  ADD_APP_CONFIG_FAILURE = '[AppConfig] ADD FAILURE',
  UPDATE_APP_CONFIG = '[AppConfig] UPDATE',
  UPDATE_APP_CONFIG_SUCCESS = '[AppConfig] UPDATE SUCCESS',
  UPDATE_APP_CONFIG_FAILURE = '[AppConfig] UPDATE FAILURE',
  UPDATE_CONFIG = '[AppConfig] UPDATE',
  UPDATE_CONFIG_SUCCESS = '[AppConfig] UPDATE SUCCESS',
  UPDATE_CONFIG_FAILURE = '[AppConfig] UPDATE FAILURE',
  DELETE_CONFIG = '[AppConfig] DELETE',
  DELETE_CONFIG_FAILURE = '[AppConfig] DELETE FAILURE',
  RENAME_CONFIG = '[AppConfig] RENAME',
  CHANGE_APP_CONFIG = '[AppConfig] CHANGE',
  DELETE_APP_CONFIG = '[AppConfig] DELETE',
  DELETE_APP_CONFIG_SUCCESS = '[AppConfig] DELETE SUCCESS',
  SELECT_APP_CONFIG = '[AppConfig] SELECT',
  FETCH_CONFIG = '[AppConfig] FETCH',
  GET_APPLICATIONS_SUCCESS = '[AppConfig] GET SUCCESS',
  GET_APPLICATIONS_FAILURE = '[AppConfig] GET FAILURE',
  SELECT_CHILD_TAB = '[device-page] SELECT CHILD TAB',
  SHOW_BATCH_RESPONSE = '[AppConfig] SHOW BATCH RESPONSE',
  ADD_SHIFT = '[SHIFT] ADD SHIFT',
  ADD_SHIFT_SUCCESS = '[SHIFT] ADD SHIFT SUCCESS',
  ADD_SHIFT_FAILURE = '[SHIFT] ADD SHIFT FAILURE',
  DELETE_SHIFT = '[SHIFT] DELETE SHIFT',
  DELETE_SHIFT_SUCCESS = '[SHIFT] DELETE SHIFT SUCCESS',
  UPDATE_SHIFT = '[SHIFT] UPDATE SHIFT',
  UPDATE_SHIFT_SUCCESS = '[SHIFT] UPDATE SHIFT SUCCESS',
  FETCH_SHIFT = '[SHIFT] FETCH SHIFT',
  FETCH_SHIFT_SUCCESS = '[SHIFT] FETCH SHIFT SUCCESS',
  FETCH_SHIFT_FAILURE = '[SHIFT] FETCH SHIFT FAILURE',
  FETCH_APP_CATEGORIES = '[AppConfig] FETCH APP CATEGORIES',
  FETCH_APP_CATEGORIES_SUCCESS = '[AppConfig] FETCH APP CATEGORIES SUCCESS',
  FETCH_APP_CATEGORIES_FAILURE = '[AppConfig] FETCH APP CATEGORIES FAILURE',
  FETCH_WEB_APP_CATEGORIES = '[AppConfig] FETCH WEB APP CATEGORIES',
  FETCH_WEB_APP_CATEGORIES_SUCCESS = '[AppConfig] FETCH WEB APP CATEGORIES SUCCESS',
  FETCH_WEB_APP_CATEGORIES_FAILURE = '[AppConfig] FETCH WEB APP CATEGORIES FAILURE',
  MAPS_LOADED = '[AppConfig] MAPS LOADED',
  UPDATE_APP_CATEGORIES = '[AppConfig] UPDATE APP CATEGORIES',
  UPDATE_APP_CATEGORIES_SUCCESS = '[AppConfig] UPDATE APP CATEGORIES SUCCESS',
  UPDATE_APP_CATEGORIES_FAILURE = '[AppConfig] UPDATE APP CATEGORIES FAILURE',
  UPDATE_WEB_APP_CATEGORIES = '[AppConfig] UPDATE WEB APP CATEGORIES',
  UPDATE_WEB_APP_CATEGORIES_SUCCESS = '[AppConfig] UPDATE WEB APP CATEGORIES SUCCESS',
  UPDATE_WEB_APP_CATEGORIES_FAILURE = '[AppConfig] UPDATE WEB APP CATEGORIES FAILURE',
  FETCH_APP_MAPPINGS = '[AppConfig] FETCH APP MAPPINGS',
  FETCH_APP_MAPPINGS_SUCCESS = '[AppConfig] FETCH APP MAPPINGS SUCCESS',
  FETCH_APP_MAPPINGS_FAILURE = '[AppConfig] FETCH APP MAPPINGS FAILURE',
  FETCH_WEB_APP_MAPPINGS = '[AppConfig] FETCH WEB APP MAPPINGS',
  FETCH_WEB_APP_MAPPINGS_SUCCESS = '[AppConfig] FETCH WEB APP MAPPINGS SUCCESS',
  FETCH_WEB_APP_MAPPINGS_FAILURE = '[AppConfig] FETCH WEB APP MAPPINGS FAILURE',
  UPDATE_APP_MAPPINGS_SUCCESS = '[AppConfig] UPDATE APP MAPPINGS SUCCESS',
  UPDATE_APP_MAPPINGS = '[AppConfig] UPDATE APP MAPPINGS',
  UPDATE_APP_MAPPINGS_FAILURE = '[AppConfig] UPDATE APP MAPPINGS FAILURE',
  UPDATE_WEB_APP_MAPPINGS_SUCCESS = '[AppConfig] UPDATE WEB APP MAPPINGS SUCCESS',
  UPDATE_WEB_APP_MAPPINGS = '[AppConfig] UPDATE WEB APP MAPPINGS',
  UPDATE_WEB_APP_MAPPINGS_FAILURE = '[AppConfig] UPDATE WEB APP MAPPINGS FAILURE',
  EDIT_APP_MAPPING = '[AppConfig] EDIT APP MAPPING',
  EDIT_WEB_APP_MAPPING = '[AppConfig] EDIT WEB APP MAPPING',
  EDIT_APP_CATEGORY = '[AppConfig] EDIT APP CATEGORY',
  EDIT_WEB_APP_CATEGORY = '[AppConfig] EDIT WEB APP CATEGORY',
  UPDATE_RATED_CAPACITY = '[AppConfig] UPDATE RATED CAPACITY',
  UPDATE_RATED_CAPACITY_SUCCESS = '[AppConfig] UPDATE RATED CAPACITY SUCCESS',
  UPDATE_RATED_CAPACITY_FAILURE = '[AppConfig] UPDATE RATED CAPACITY FAILURE',
}

export class InitAppAction implements Action {
  readonly type = ROOT_EFFECTS_INIT;
}

export class SelectChildTabAction implements Action {
  readonly type = AppConfigActionTypes.SELECT_CHILD_TAB;
  constructor(public appId: string, public tabId: string) {}
}

export class AddAppConfigAction implements Action {
  readonly type = AppConfigActionTypes.ADD_APP_CONFIG;

  constructor(public appConfig: ApplicationConfig) {}
}

export class AddAppConfigSuccessAction implements Action {
  readonly type = AppConfigActionTypes.ADD_APP_CONFIG_SUCCESS;

  constructor(public appConfig: ApplicationConfigWithPages, public addFirst: boolean) {}
}

export class AddAppConfigFailureAction implements Action {
  readonly type = AppConfigActionTypes.ADD_APP_CONFIG_FAILURE;

  constructor(public error: any) {}
}

export class UpdateAppConfigAction implements Action {
  readonly type = AppConfigActionTypes.UPDATE_APP_CONFIG;

  constructor(public appConfig: ApplicationConfig) {}
}

export class UpdateAppConfigSuccessAction implements Action {
  readonly type = AppConfigActionTypes.UPDATE_APP_CONFIG_SUCCESS;

  constructor(public appConfig: ApplicationConfig) {}
}

export class UpdateAppConfigFailureAction implements Action {
  readonly type = AppConfigActionTypes.UPDATE_APP_CONFIG_FAILURE;

  constructor(public error: any) {}
}

export class DeleteAppConfigAction implements Action {
  readonly type = AppConfigActionTypes.DELETE_APP_CONFIG;

  constructor(public id: string, public previousId?: string) {}
}

export class DeleteAppConfigSuccessAction implements Action {
  readonly type = AppConfigActionTypes.DELETE_APP_CONFIG_SUCCESS;

  constructor(public id: string) {}
}

export class UpdateConfigAction implements Action {
  readonly type = AppConfigActionTypes.UPDATE_CONFIG;
}

export class UpdateConfigSuccessAction implements Action {
  readonly type = AppConfigActionTypes.UPDATE_CONFIG_SUCCESS;

  constructor(public appConfig: ApplicationConfig) {}
}

export class UpdateConfigFailureAction implements Action {
  readonly type = AppConfigActionTypes.UPDATE_CONFIG_FAILURE;

  constructor(public error: any) {}
}

export class DeleteConfigAction implements Action {
  readonly type = AppConfigActionTypes.DELETE_CONFIG;

  constructor(public id: string) {}
}

export class DeleteConfigFailureAction implements Action {
  readonly type = AppConfigActionTypes.DELETE_CONFIG_FAILURE;

  constructor(public error: any) {}
}

export class RenameCurrentConfigAction implements Action {
  readonly type = AppConfigActionTypes.RENAME_CONFIG;

  constructor(public name: string) {}
}

export class SelectCurrentAppConfigAction implements Action {
  readonly type = AppConfigActionTypes.SELECT_APP_CONFIG;

  constructor(public id: string, public appMode: AppMode = undefined) {}
}

export class ChangeAppConfig implements Action {
  readonly type = AppConfigActionTypes.CHANGE_APP_CONFIG;
  constructor(
    public appConfig: ApplicationConfig,
    public pageId: string,
    public profileChanged: boolean = false,
    public initialLoad: boolean = false,
    public appMode: AppMode = undefined
  ) {}
}

export class FetchConfigsAction implements Action {
  readonly type = AppConfigActionTypes.FETCH_CONFIG;
}

export class GetSuccessAppConfigAction implements Action {
  readonly type = AppConfigActionTypes.GET_APPLICATIONS_SUCCESS;

  constructor(public applications: ApplicationConfigWithPages[]) {}
}

export class GetFailureAppConfigAction implements Action {
  readonly type = AppConfigActionTypes.GET_APPLICATIONS_FAILURE;

  constructor(public error: any) {}
}

export class ShowBatchResponse implements Action {
  readonly type = AppConfigActionTypes.SHOW_BATCH_RESPONSE;
}

export class AddShift implements Action {
  readonly type = AppConfigActionTypes.ADD_SHIFT;

  constructor(public shift: Shifts) {}
}

export class DeleteShift implements Action {
  readonly type = AppConfigActionTypes.DELETE_SHIFT;

  constructor(public id: number) {}
}

export class UpdateShift implements Action {
  readonly type = AppConfigActionTypes.UPDATE_SHIFT;

  constructor(public shift: Shifts) {}
}

export class FetchShift implements Action {
  readonly type = AppConfigActionTypes.FETCH_SHIFT;
}

export class FetchShiftSuccess implements Action {
  readonly type = AppConfigActionTypes.FETCH_SHIFT_SUCCESS;

  constructor(public shifts: Shifts[]) {}
}

export class FetchShiftFailure implements Action {
  readonly type = AppConfigActionTypes.FETCH_SHIFT_FAILURE;
}

export class DeleteShiftSuccess implements Action {
  readonly type = AppConfigActionTypes.DELETE_SHIFT_SUCCESS;

  constructor(public id: number) {}
}

export class UpdateShiftSuccess implements Action {
  readonly type = AppConfigActionTypes.UPDATE_SHIFT_SUCCESS;

  constructor(public shift: Shifts, public shiftId: number) {}
}

export class AddShiftSuccess implements Action {
  readonly type = AppConfigActionTypes.ADD_SHIFT_SUCCESS;

  constructor(public shift: Shifts, public id: number) {}
}

export class AddShiftFailure implements Action {
  readonly type = AppConfigActionTypes.ADD_SHIFT_FAILURE;

  constructor(public error: any) {}
}

export class MapsLoadedAction implements Action {
  readonly type = AppConfigActionTypes.MAPS_LOADED;

  constructor(public success: boolean) {}
}

export class FetchAppCategories implements Action {
  readonly type = AppConfigActionTypes.FETCH_APP_CATEGORIES;
}

export class FetchAppCategoriesFailure implements Action {
  readonly type = AppConfigActionTypes.FETCH_APP_CATEGORIES_FAILURE;

  constructor(public error: any) {}
}

export class FetchAppCategoriesSuccess implements Action {
  readonly type = AppConfigActionTypes.FETCH_APP_CATEGORIES_SUCCESS;

  constructor(public appCategories: AppCategory[]) {}
}

export class FetchWebAppCategories implements Action {
  readonly type = AppConfigActionTypes.FETCH_WEB_APP_CATEGORIES;
}

export class FetchWebAppCategoriesFailure implements Action {
  readonly type = AppConfigActionTypes.FETCH_WEB_APP_CATEGORIES_FAILURE;

  constructor(public error: any) {}
}

export class FetchWebAppCategoriesSuccess implements Action {
  readonly type = AppConfigActionTypes.FETCH_WEB_APP_CATEGORIES_SUCCESS;

  constructor(public appCategories: WebAppCategory[]) {}
}

export class UpdateAppCategories implements Action {
  readonly type = AppConfigActionTypes.UPDATE_APP_CATEGORIES;

  constructor(public categories: AppCategory[], public mappings: AppMappings[]) {}
}

export class UpdateAppCategoriesSuccess implements Action {
  readonly type = AppConfigActionTypes.UPDATE_APP_CATEGORIES_SUCCESS;

  constructor(public appCategories: AppCategory[]) {}
}

export class UpdateAppCategoriesFailure implements Action {
  readonly type = AppConfigActionTypes.UPDATE_APP_CATEGORIES_FAILURE;

  constructor(public error: any) {}
}

export class UpdateWebAppCategories implements Action {
  readonly type = AppConfigActionTypes.UPDATE_WEB_APP_CATEGORIES;

  constructor(public categories: WebAppCategory[], public mappings: WebAppMapping[]) {}
}

export class UpdateWebAppCategoriesSuccess implements Action {
  readonly type = AppConfigActionTypes.UPDATE_WEB_APP_CATEGORIES_SUCCESS;

  constructor(public appCategories: WebAppCategory[]) {}
}

export class UpdateWebAppCategoriesFailure implements Action {
  readonly type = AppConfigActionTypes.UPDATE_WEB_APP_CATEGORIES_FAILURE;

  constructor(public error: any) {}
}

export class UpdateAppMappings implements Action {
  readonly type = AppConfigActionTypes.UPDATE_APP_MAPPINGS;

  constructor(public mappings: AppMappings[]) {}
}

export class UpdateAppMappingsSuccess implements Action {
  readonly type = AppConfigActionTypes.UPDATE_APP_MAPPINGS_SUCCESS;

  constructor(public mappings: AppMappings[]) {}
}

export class UpdateAppMappingsFailure implements Action {
  readonly type = AppConfigActionTypes.UPDATE_APP_MAPPINGS_FAILURE;

  constructor(public error: any) {}
}

export class UpdateWebAppMappings implements Action {
  readonly type = AppConfigActionTypes.UPDATE_WEB_APP_MAPPINGS;

  constructor(public mappings: WebAppMapping[]) {}
}

export class UpdateWebAppMappingsSuccess implements Action {
  readonly type = AppConfigActionTypes.UPDATE_WEB_APP_MAPPINGS_SUCCESS;

  constructor(public mappings: WebAppMapping[]) {}
}

export class UpdateWebAppMappingsFailure implements Action {
  readonly type = AppConfigActionTypes.UPDATE_WEB_APP_MAPPINGS_FAILURE;

  constructor(public error: any) {}
}

export class FetchAppMappings implements Action {
  readonly type = AppConfigActionTypes.FETCH_APP_MAPPINGS;
}

export class FetchAppMappingsSuccess implements Action {
  readonly type = AppConfigActionTypes.FETCH_APP_MAPPINGS_SUCCESS;

  constructor(public mappings: AppMappings[]) {}
}

export class FetchAppMappingsFailure implements Action {
  readonly type = AppConfigActionTypes.FETCH_APP_MAPPINGS_FAILURE;

  constructor(public error: any) {}
}

export class FetchWebAppMappings implements Action {
  readonly type = AppConfigActionTypes.FETCH_WEB_APP_MAPPINGS;
}

export class FetchWebAppMappingsSuccess implements Action {
  readonly type = AppConfigActionTypes.FETCH_WEB_APP_MAPPINGS_SUCCESS;

  constructor(public mappings: WebAppMapping[]) {}
}

export class FetchWebAppMappingsFailure implements Action {
  readonly type = AppConfigActionTypes.FETCH_WEB_APP_MAPPINGS_FAILURE;

  constructor(public error: any) {}
}

export class EditAppMapping implements Action {
  readonly type = AppConfigActionTypes.EDIT_APP_MAPPING;

  constructor(public mappings: AppMappings[]) {}
}

export class EditWebAppMapping implements Action {
  readonly type = AppConfigActionTypes.EDIT_WEB_APP_MAPPING;

  constructor(public mappings: WebAppMapping[]) {}
}

export class EditAppCategory implements Action {
  readonly type = AppConfigActionTypes.EDIT_APP_CATEGORY;

  constructor(public appCategories: AppCategory[]) {}
}

export class EditWebAppCategory implements Action {
  readonly type = AppConfigActionTypes.EDIT_WEB_APP_CATEGORY;

  constructor(public appCategories: WebAppCategory[]) {}
}

export class UpdateRatedCapacity implements Action {
  readonly type = AppConfigActionTypes.UPDATE_RATED_CAPACITY;
  constructor(public rcap: RatedCapacity[]) {}
}

export class UpdateRatedCapacitySuccess implements Action {
  readonly type = AppConfigActionTypes.UPDATE_RATED_CAPACITY_SUCCESS;
  constructor(public rcap: RatedCapacity[]) {}
}

export class UpdateRatedCapacityFailure implements Action {
  readonly type = AppConfigActionTypes.UPDATE_RATED_CAPACITY_FAILURE;

  constructor(public error: any) {}
}

export type AppConfigActions =
  | InitAppAction
  | AddAppConfigAction
  | AddAppConfigSuccessAction
  | AddAppConfigFailureAction
  | UpdateAppConfigAction
  | UpdateAppConfigSuccessAction
  | UpdateAppConfigFailureAction
  | DeleteAppConfigSuccessAction
  | UpdateConfigAction
  | UpdateConfigSuccessAction
  | UpdateConfigFailureAction
  | DeleteConfigAction
  | DeleteConfigFailureAction
  | SelectCurrentAppConfigAction
  | ChangeAppConfig
  | FetchConfigsAction
  | GetSuccessAppConfigAction
  | GetFailureAppConfigAction
  | SelectChildTabAction
  | ShowBatchResponse
  | AddShift
  | AddShiftFailure
  | DeleteShift
  | UpdateShift
  | FetchShift
  | FetchShiftSuccess
  | FetchShiftFailure
  | DeleteShiftSuccess
  | UpdateShiftSuccess
  | AddShiftSuccess
  | MapsLoadedAction
  | FetchAppCategories
  | FetchAppCategoriesSuccess
  | FetchAppCategoriesFailure
  | FetchWebAppCategories
  | FetchWebAppCategoriesSuccess
  | FetchWebAppCategoriesFailure
  | UpdateAppCategories
  | UpdateAppCategoriesSuccess
  | UpdateAppCategoriesFailure
  | UpdateWebAppCategories
  | UpdateWebAppCategoriesSuccess
  | UpdateWebAppCategoriesFailure
  | FetchAppMappings
  | FetchAppMappingsSuccess
  | FetchAppMappingsFailure
  | FetchWebAppMappings
  | FetchWebAppMappingsSuccess
  | FetchWebAppMappingsFailure
  | UpdateAppMappings
  | UpdateAppMappingsSuccess
  | UpdateAppMappingsFailure
  | UpdateWebAppMappings
  | UpdateWebAppMappingsSuccess
  | UpdateWebAppMappingsFailure
  | EditAppMapping
  | EditWebAppMapping
  | EditAppCategory
  | EditWebAppCategory
  | UpdateRatedCapacity
  | UpdateRatedCapacitySuccess
  | UpdateRatedCapacityFailure;
